import ApiHelper from "./ApiHelper.js";

const requestOptions = { suppressAuthStatus: true };

export function createPortfolioGeneration() {
    return ApiHelper.post("/api/portfolio-generations", null, requestOptions);
}

export function getPortfolioGeneration(generationId) {
    return ApiHelper.get(
        `/api/portfolio-generations/${encodeURIComponent(generationId)}`,
        null,
        requestOptions
    );
}

export function getPortfolioGenerationTemplates() {
    return ApiHelper.get("/api/portfolio-generations/templates", null, requestOptions);
}

export function portfolioGenerationAssetUrl(generationId, sourceAssetId) {
    return `/api/portfolio-generations/${encodeURIComponent(generationId)}/assets/${encodeURIComponent(sourceAssetId)}`;
}

export function claimPortfolioGeneration(generationId) {
    return ApiHelper.post(
        `/api/portfolio-generations/${encodeURIComponent(generationId)}/claim`,
        null,
        requestOptions
    );
}

export function materializePortfolioGeneration(generationId) {
    return ApiHelper.post(
        `/api/portfolio-generations/${encodeURIComponent(generationId)}/materialize`,
        null,
        requestOptions
    );
}

export function collectPortfolioGenerationSources(generationId, formData) {
    return ApiHelper.postMultipart(
        `/api/portfolio-generations/${encodeURIComponent(generationId)}/sources`,
        formData,
        requestOptions
    );
}

export function analyzePortfolioGeneration(generationId, options = {}) {
    const query = options.allowBlueprintWithFollowUp ? "?allowBlueprintWithFollowUp=true" : "";
    return ApiHelper.post(
        `/api/portfolio-generations/${encodeURIComponent(generationId)}/analyze${query}`,
        null,
        requestOptions
    );
}

export function submitPortfolioGenerationFollowUp(generationId, answers) {
    return ApiHelper.post(
        `/api/portfolio-generations/${encodeURIComponent(generationId)}/follow-up`,
        { answers },
        requestOptions
    );
}

export function generatePortfolioBlueprint(generationId) {
    return ApiHelper.post(
        `/api/portfolio-generations/${encodeURIComponent(generationId)}/generate`,
        null,
        requestOptions
    );
}

export function refinePortfolioGenerationContent(generationId, formData) {
    return ApiHelper.postMultipart(
        `/api/portfolio-generations/${encodeURIComponent(generationId)}/refine-content`,
        formData,
        requestOptions
    );
}

export function getPortfolioGenerationPreview(generationId) {
    return ApiHelper.get(
        `/api/portfolio-generations/${encodeURIComponent(generationId)}/preview`,
        null,
        requestOptions
    );
}

export function updatePortfolioGenerationVisualConfiguration(generationId, configuration) {
    return ApiHelper.patch(
        `/api/portfolio-generations/${encodeURIComponent(generationId)}/visual-configuration`,
        configuration,
        requestOptions
    );
}

export function updatePortfolioGenerationTemplate(generationId, templatePortfolioShortId) {
    return ApiHelper.patch(
        `/api/portfolio-generations/${encodeURIComponent(generationId)}/template`,
        { templatePortfolioShortId },
        requestOptions
    );
}

export default {
    create: createPortfolioGeneration,
    get: getPortfolioGeneration,
    getTemplates: getPortfolioGenerationTemplates,
    assetUrl: portfolioGenerationAssetUrl,
    claim: claimPortfolioGeneration,
    materialize: materializePortfolioGeneration,
    collectSources: collectPortfolioGenerationSources,
    analyze: analyzePortfolioGeneration,
    submitFollowUp: submitPortfolioGenerationFollowUp,
    generateBlueprint: generatePortfolioBlueprint,
    refineContent: refinePortfolioGenerationContent,
    getPreview: getPortfolioGenerationPreview,
    updateVisualConfiguration: updatePortfolioGenerationVisualConfiguration,
    updateTemplate: updatePortfolioGenerationTemplate
};
